const getQueryParams = (link) => {
  if (typeof window === 'undefined') return {};
  const currentUrl = link || window.location.href;

  const [baseLink, fragment] = currentUrl.split('#');
  const paramsString = baseLink.split('?')[1];
  const paramsArray = paramsString?.split('&') || [];

  const params = {};
  paramsArray.forEach((paramString) => {
    const [key, value] = paramString.split('=');
    params[key] = value;
  });

  return { params, fragment };
};

export const getLinkWithQueryParams = (link) => {
  if (!link) return {};
  if (typeof window === 'undefined') return link;

  const { params: locationParams } = getQueryParams();
  const { params: linkParams, fragment } = getQueryParams(link);

  if (!Object.keys(locationParams).length) return link;

  let [linkWithoutQuery] = link.split('?');

  // link query params are higher priority so they should override location query params
  const paramsToSet = { ...locationParams, ...linkParams };

  const paramsEntries = Object.entries(paramsToSet).filter(
    ([, paramValue]) => !!paramValue
  );

  const url = paramsEntries.reduce((acc, curr, index) => {
    const [key, value] = curr;
    if (!value) return acc;
    if (!index) acc += '?';
    const isLastStep = index === paramsEntries.length - 1;
    let additionalString = '';
    if (isLastStep) {
      if (fragment) additionalString = `#${fragment}`;
    } else {
      additionalString = '&';
    }
    return (acc += `${key}=${value}${additionalString}`);
  }, linkWithoutQuery);

  return url;
};
